import { Component, inject } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { Icon, Link } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cfp-login-sso',
  templateUrl: './login-sso.html',
  imports: [Link, Icon, TranslateModule]
})
export class LoginSso {
  private readonly environment = inject(ENVIRONMENT);

  protected showLoginUsingSso = this.environment.components.showLoginUsingSso === true;

  protected ssoLoginUrl =
    this.environment.enabledFeatures?.ssoOauth === true
      ? `/csr/app/${this.environment.environmentCode.path}/login/auth/login/auth-sso`
      : `/csr/api/saml2/login/${this.environment.environmentCode.path}`;
}
